import React, { Component } from 'react';
import { getAuthUIConfig } from 'features/ContentAPI';

const withUIConfig = (WrappedComponent) => {
    return class WithAuthUIConfig extends Component {
        state = {
            authUIConfig: null,
            authUIConfigRequestError: false,
        };

        componentDidMount() {
            getAuthUIConfig()
                .then((res) =>
                    this.setState({
                        authUIConfig: res,
                    })
                )
                .catch((e) => {
                    console.log(e);
                    this.setState({ authUIConfigRequestError: true });
                });
        }

        render() {
            const { authUIConfig, authUIConfigRequestError } = this.state;
            return (
                <WrappedComponent
                    {...this.props}
                    authUIConfig={authUIConfig}
                    authUIConfigRequestError={authUIConfigRequestError}
                />
            );
        }
    };
};

export default withUIConfig;
